export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_03.da172603.jpg";